const projects = [
  {
    id: 5,
    title: 'Personal Site - Yes! This one!',
    description: "A React portfolio site — you're looking at it. Responsive, clean, and built from scratch.",
    tags: ['React', 'CSS'],
    demoLink: null,
    codeLink: 'https://github.com/LoamySand/PersonalSite/tree/gh-pages'
  },
  {
    id: 2,
    title: 'BackOfYourHand.org',
    description: 'A learning experience for the directionally challenged. Back Of Your Hand is a MERN-stack geography game that challenges players to locate streets on a map. ',
    tags: ['React', 'ExpressJS', 'MongoDB'],
    demoLink: 'https://www.backofyourhand.org/',
    codeLink: 'https://github.com/LoamySand/BackOfYourHand'
  },
  {
    id: 1,
    title: "What's Popping ABQ?",
    description: 'Automated data pipeline analyzing the impact of events on local traffic, businesses, and community sentiment in Albuquerque, NM.',
    tags: ['Python', 'Prefect', 'PostgreSQL', 'Docker'],
    demoLink: 'https://whatspoppingabq.streamlit.app/',
    codeLink: 'https://github.com/LoamySand/whatspoppingABQ'
  },
  {
    id: 3,
    title: 'Salvation Army Resident Services Tracker',
    description: 'A shelter management tool built for the Salvation Army to streamline tracking of resident visits and services, with built-in reporting.',
    tags: ['ExpressJS', 'MongoDB', 'TypeScript'],
    demoLink: null,
    codeLink: 'https://github.com/LoamySand/CodeColonels'
  },
];

export default projects;
